var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "current",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.385 50.385c-10.153 10.153-26.616 10.153-36.77 0s-10.153-26.616 0-36.77 26.616-10.153 36.77 0 10.153 26.616 0 36.77m-7.071-9.9L36.243 32l7.071-8.485-2.828-2.828L32 27.757l-8.485-7.071-2.828 2.828L27.757 32l-7.071 8.485 2.828 2.828L32 36.243l8.485 7.071z"
  })));
};
export default SvgClose;